<template>
  <div class="home-page">
    <div class="row">
      <div v-if="Can(rights.CANDIDATE_VIEW) && !Can(rights.IS_CUSTOMER)" class="col-md-6 col-lg-4">
         <card
            :number="getLastMonthCandidates"
            :title="'Kandidaten deze maand'"
            :icon="'fad fa-users'"
            :type="'primary'"
        >
        </card>
      </div>
      <div v-if="Can(rights.CANDIDATE_VIEW) && !Can(rights.IS_CUSTOMER)" class="col-md-6 col-lg-4">
        <card
            :number="getSickCandidates"
            :title="'Zieken vandaag'"
            :icon="'fad fa-user-injured'"
            :type="'secondary'"
        >
        </card>
      </div>
      <div v-if="Can(rights.CANDIDATE_VIEW) && !Can(rights.IS_CUSTOMER)" class="col-md-6 col-lg-4">
        <card
            :number="getLastWeekPlacements"
            :title="'Plaatsingen deze week'"
            :icon="'fad fa-person-dolly'"
            :type="'primary'"
        >
        </card>
      </div>
    </div>
    <div class="row rm-p-portlet">
      <div class="col-lg-4" v-if="Can(rights.CANDIDATE_VIEW) && !Can(rights.IS_CUSTOMER)">
        <portlet
            :icon="'fad fa-users'"
            :title="'Kandidaten'"
            :actionsBlock="true"
        >
          <template v-if="Can(rights.CANDIDATE_ADD)" slot="actionsBlock">
            <router-link tag="button" :to="{name:'candidate-create'}" class="btn btn-secondary">
              <i class="fas fa-plus-circle mr-2"></i> Toevoegen
            </router-link>
          </template>
          <template v-if="Can(rights.CANDIDATE_VIEW)" slot="portletBody">
            <datatables
                :tableClass="tableClass"
                v-if="getCandidatesByCreated_at.length"
                :rows="getCandidatesByCreated_at.slice(-12)"
                :columns="columnsCandidates"
                tableID="candidates-home"
                :tableInitOptions="tableInitOptions"
                routerLinkClass="dt-router-link"
            />
          </template>
        </portlet>
      </div>
      <div class="col-lg-4" v-if="Can(rights.VACANCY_VIEW) && !Can(rights.IS_CUSTOMER)">
        <portlet
            :icon="'fad fa-file-contract'"
            :title="'Vacatures'"
            :actionsBlock="true"
        >
          <template v-if="Can(rights.VACANCY_ADD)" slot="actionsBlock">
            <router-link tag="button" :to="{name:'vacancy-create'}" class="btn btn-secondary">
              <i class="fas fa-plus-circle mr-2"></i> Toevoegen
            </router-link>
          </template>
          <template v-if="Can(rights.VACANCY_VIEW)" slot="portletBody">
            <datatables
                :tableClass="tableClass"
                v-if="getVacancies.length && renderedComponent"
                :rows="getVacancies.slice(-12)"
                :columns="columnsVacancies"
                tableID="vacancies-home"
                :tableInitOptions="tableInitOptions"
                routerLinkClass="dt-router-link"
            ></datatables>
          </template>
        </portlet>
      </div>
      <div class="col-lg-4" v-if="Can(rights.CUSTOMER_VIEW) && !Can(rights.IS_CUSTOMER)">
        <portlet
            :icon="'fad fa-building'"
            :title="'Bedrijven'"
            :actionsBlock="true"
        >
          <template v-if="Can(rights.CUSTOMER_ADD)" slot="actionsBlock">
            <router-link tag="button" :to="{name:'customer-create'}" class="btn btn-secondary">
              <i class="fas fa-plus-circle mr-2"></i> Toevoegen
            </router-link>
          </template>
          <template v-if="Can(rights.CUSTOMER_VIEW)" slot="portletBody">
            <datatables
                :tableClass="tableClass"
                v-if="getCustomers.length"
                :rows="getCustomers.slice(-12)"
                :columns="columnsCustomers"
                tableID="customers-home"
                :tableInitOptions="tableInitOptions"
                routerLinkClass="dt-router-link"
            ></datatables>
          </template>
        </portlet>
      </div>
      <div class="col-lg-4" v-if="Can(rights.IS_CUSTOMER)">
        <portlet
            :icon="'fad fa-file-contract'"
            :title="'Active employees'"
            :actionsBlock="true"
        >
          <template slot="portletBody">
            <datatables
                :tableClass="tableClass"
                v-if="getFlexworkers.length && renderedComponent"
                :rows="getFlexworkers.slice(-12)"
                :columns="columnsFlexworkers"
                tableID="flexworkers-home"
                :tableInitOptions="getTableInitOptions(0)"
                routerLinkClass="dt-router-link"
            ></datatables>
          </template>
        </portlet>
      </div>
      <div class="col-lg-4" v-if="Can(rights.IS_CUSTOMER)">
        <portlet
            :icon="'fad fa-file-contract'"
            :title="'Sick employees'"
            :actionsBlock="true"
        >
          <template slot="portletBody">
            <datatables
                :tableClass="tableClass"
                v-if="getSickLeaves.length && renderedComponent"
                :rows="getSickLeaves.slice(-12)"
                :columns="columnsSickLeaves"
                tableID="sick-leaves-home"
                :tableInitOptions="tableInitOptions"
                routerLinkClass="dt-router-link"
            ></datatables>
          </template>
        </portlet>
      </div>
      <div class="col-lg-4" v-if="Can(rights.IS_CUSTOMER)">
        <portlet
            :icon="'fad fa-file-contract'"
            :title="'Leave requests'"
            :actionsBlock="true"
        >
          <template slot="portletBody">
            <datatables
                :tableClass="tableClass"
                v-if="(filterLeaveRequests()).length && renderedComponent"
                :rows="(filterLeaveRequests()).slice(-12)"
                :columns="columnsLeaveRequests"
                tableID="leave-requests-home"
                :tableInitOptions="tableInitOptions"
                routerLinkClass="dt-router-link"
            ></datatables>
          </template>
        </portlet>
      </div>
    </div>
  </div>
</template>

<script>
  var strontbroekTrack = new Audio('strontbroek.mp3')
  import {mapGetters} from 'vuex'
  import {dataTables} from '../components/mixins/dataTables'
  import { Can } from '../../permission/ability';
  import { RIGHTS } from './roles/rights';
  import store from '../store.js';
  import Vue from 'vue';

  export default {
    mixins: [dataTables],
    methods:{
      Can,
      filterLeaveRequests() {
        return this.getLeaveRequests.filter((leaveRequest) => {
          return moment(leaveRequest.date).isSame(moment(), 'day');
        });
      },
      getTableInitOptions(order) {
        return {
          searching: false,
          paging: false,
          info: false,
          order: [[order, 'desc']]
        }
      }
    },
    data() {
      return {
        rights: '',
        birth: null,
        candidate: null,
        tableInitOptions: {
          searching: false,
          paging: false,
          info: false,
          order: [[2, 'desc']]
        },
        columnsCandidates: [
          {
            data: null, name: 'Persoon', visible: true, orderable:false,responsivePriority: 1,
            render(data) {
              return '<a data-to="/candidates/' + data.id + '" class="dt-router-link">' + data.firstName + ' ' + data.lastName + '</a>'
            }
          },
          {
            data: null, name: 'Datum', visible: true,orderable:false,
            render(data) {
              return moment(data.created_at).format('DD-MM-YYYY');
            }
          },
          {data: null, visible: false,
            render(data) {
              return data.created_at ? data.created_at : new Date();
            }}
        ],
        columnsVacancies: [
          {
            data: null, name: 'Vacature', visible: true, orderable:false,responsivePriority: 1,
            render(data) {
              return '<a data-to="/vacancies/' + data.id + '" class="dt-router-link">' + data.name + '</a>'
            }
          },
          {
            data: null, name: 'Datum', visible: true,orderable:false,
            render(data) {
              return moment(data.created_at).format('DD-MM-YYYY');
            }
          },
          {data: 'created_at', visible: false}
        ],
        columnsCustomers: [
          {
            data: null, name: 'Bedrijf', visible: true, orderable:false,responsivePriority: 1,
            render(data) {
              return '<a data-to="/customers/' + data.id + '" class="dt-router-link">' + data.name + '</a>'
            }
          },
          {
            data: null, name: 'Datum', visible: true,orderable:false,
            render(data) {
              return moment(data.created_at).format('DD-MM-YYYY');
            }
          },
          {data: 'created_at', visible: false}
        ],
        columnsFlexworkers: [
          {
            data: null, name: 'Employee', visible: true, orderable:false,responsivePriority: 1,
            render(data) {
              return '<div>' + data.name + '</div>'
            }
          }
        ],
        columnsSickLeaves: [
          {
            data: null, name: 'Employee', visible: true, orderable:false,responsivePriority: 1,
            render(data) {
              return '<div>' + data.employment.flexworker + '</div>'
            }
          },
          {
            data: null, name: 'Start date', visible: true,orderable:false,
            render(data) {
              return moment(data.start_date).format('DD-MM-YYYY');
            }
          },
          {data: 'created_at', visible: false}
        ],
        columnsLeaveRequests: [
          {
            data: null, name: 'Employee', visible: true, orderable:false,responsivePriority: 1,
            render(data) {
              return '<div>' + data.employment.flexworker + '</div>'
            }
          },
          {
            data: null, name: 'Date', visible: true,orderable:false,
            render(data) {
              return moment(data.date).format('DD-MM-YYYY');
            }
          },
          {
            data: null, name: 'Hours', visible: true,orderable:false,
            render(data) {
              return data.hours;
            }
          },
        ]
      }
    },
    computed: {
      ...mapGetters('candidates', [
        'getCandidates',
        'getCandidatesByCreated_at',
        'getLastMonthCandidates',
        'getSickCandidates'
      ]),
      ...mapGetters('placements', [
        'getActivePlacements',
        'getLastWeekPlacements'
      ]),
      ...mapGetters('vacancies', [
        'getVacancies'
      ]),
      ...mapGetters('customers', [
        "getCustomers",
      ]),
      ...mapGetters('users', [
        "getUserData",
      ]),
      ...mapGetters('flexworkers', [
        'getFlexworkers',
        'getAll'
      ]),
      ...mapGetters('sickLeaves', [
        'getSickLeaves'
      ]),
      ...mapGetters('leaveRequests', [
        'getLeaveRequests'
      ])
    },
    created() {
      this.rights = RIGHTS;
      if(this.$route.params.music === 'play') {
        strontbroekTrack.play()
      }
      store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments})
      store.dispatch('sickLeaves/getSickLeavesOpen', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments})
      store.dispatch('leaveRequests/getLeaveRequests', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments})
    }
  }
</script>
